import Login from "../../../auth/login";
import Register from "../../../auth/register";
import ForgotPassword from "../../../auth/forgot-password";
import ResetPassword from "../../../auth/reset-password";

export const publicRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  // {
  //   path: "/register",
  //   component: <Register />,
  // },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    component: <ResetPassword />,
  },
  // {
  //   path: "/forgot-password-response",
  //   // component: <ForgotPasswordResponse />,
  // },
];
